import React from 'react';
import { AuthContext } from '.';

export const useAuth = () => {
  return React.useContext(AuthContext);
};
